import { render, staticRenderFns } from "./CommentEditor.vue?vue&type=template&id=11f01357&scoped=true&"
import script from "./CommentEditor.vue?vue&type=script&lang=js&"
export * from "./CommentEditor.vue?vue&type=script&lang=js&"
import style0 from "./CommentEditor.vue?vue&type=style&index=0&id=11f01357&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f01357",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
